type RunControl = {
  status: string;
  pauseSupported?: boolean;
  pauseRequestedAt?: number | null;
  pauseAcknowledgedAt?: number | null;
  controlState?: "running" | "pause_requested" | "paused";
};

export type WorkflowRunPauseState = "pausing" | "paused" | null;

const PAUSEABLE_WORKFLOW_STATUSES = new Set(["queued", "running", "sleeping", "paused"]);
const RETRYABLE_WORKFLOW_STATUSES = new Set(["failed", "timed_out", "cancelled"]);

export function isRetryableWorkflowRunStatus(status: string): boolean {
  return RETRYABLE_WORKFLOW_STATUSES.has(status.toLowerCase());
}

export function workflowRunPauseState(run: RunControl): WorkflowRunPauseState {
  if (!PAUSEABLE_WORKFLOW_STATUSES.has(run.status)) return null;
  if (run.status === "paused") return "paused";
  if (run.controlState === "paused") return "paused";
  if (run.controlState === "pause_requested" || typeof run.pauseRequestedAt === "number") return "pausing";
  return null;
}

export function workflowRunPauseRequested(run: RunControl): boolean {
  return workflowRunPauseState(run) === "pausing";
}

export function workflowRunConfirmedPaused(run: RunControl): boolean {
  return workflowRunPauseState(run) === "paused";
}

/** Only the server can opt a workflow into checkpoint-safe pause/resume. */
export function workflowRunControlAction(run: RunControl): "pause" | "resume" | null {
  if (!run.pauseSupported || !PAUSEABLE_WORKFLOW_STATUSES.has(run.status)) return null;
  return workflowRunPauseState(run) !== null
    ? "resume"
    : "pause";
}
